/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { logout } from "../../actions/auth";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Menu } from "antd";
import {
	BarChartOutlined,
	DatabaseOutlined,
	PieChartOutlined,
	TeamOutlined,
	UserOutlined,
	HomeOutlined,
	TruckOutlined,
	FileOutlined,
	UploadOutlined,
	WechatWorkOutlined,
	SettingOutlined,
	ProfileOutlined,
	LogoutOutlined,
	UnorderedListOutlined,
	ProductOutlined,
	SlidersFilled,
	WarningOutlined,
	AreaChartOutlined,
	BuildOutlined,
	ForwardOutlined,
} from "@ant-design/icons";
import NotificationManager from "./NotificationManager";
import hasPermission from "../../utils/permissions";

function getItem(label, key, icon, children) {
	return {
		key,
		icon,
		children,
		label,
	};
}

const CustomMenu = ({
	history,
	auth: { isAuthenticated, loading },
	logout,
}) => {
	const items = [
		hasPermission("menu:home") &&
			getItem("Home", "dashboardmanagement", <HomeOutlined />),

		hasPermission("menu:sales") &&
			getItem("Sales", "sales", <BarChartOutlined />, [
				hasPermission("sales:customers") &&
					getItem("Customers", "client/list", <UserOutlined />),
				getItem("Customer Profile", "customer/profile/new", <UserOutlined />),
				getItem("Credits", "creditlist"),
				hasPermission("sales:sms") &&
					getItem("SMS", "smslist", <WechatWorkOutlined />),
				getItem("Sales Dashboard", "salesdashboard"),
				getItem("Profitability Report", "report/profitability"),
				// getItem("Profitability Report 2", "report/profitability2"),
				// getItem("Opportunity Status", "opportunitystatus"),
				getItem("Quadrants", "quadrants"),
				getItem("Top Customers", "topcustomers"),
				getItem("Top Localities", "toplocalities"),
				getItem("Top Foreman", "topforeman"),
				getItem("Report Customer Sales", "reportcustomersales"),
				getItem("List Price", "listprice"),
				hasPermission("sales:opportunity-dashboard") &&
					getItem("Opportunity Dashboard", "opportunity/dashboard"),
				getItem("Price Report", "reports/jobs/price"),
				hasPermission("sales:prospect-dashboard") &&
					getItem("Prospect", "prospect/dashboard", <UserOutlined />),
				// hasPermission("sales:follow-up-dashboard") &&
				// 	getItem("Follow Up", "followup/dashboard", <ForwardOutlined />),
				getItem("Customer Follow Up", "followup/customer", <ForwardOutlined />),
				hasPermission("sales:daily-seller") &&
					getItem(
						"Daily Seller Dashboard",
						"dailyseller",
						<DatabaseOutlined />,
					),
				hasPermission("sales:sales-by-seller") &&
					getItem("Sales by seller", "salesbyseller"),
				getItem("Seller Report", "report/sales/seller"),
				getItem("Job Performance", "report/job/performance"),
			]),

		hasPermission("menu:job") &&
			getItem("Job", "job", <BarChartOutlined />, [
				getItem("New Job", "jobnuevo"),
				getItem("New In Call", "quotenew"),
				getItem("New Quote", "newquote"),
				getItem("Quote List", "quotelisting"),
			]),

		hasPermission("menu:daily-appointment") &&
			getItem("Daily Appointment", "dailyappointment", <DatabaseOutlined />),

		hasPermission("menu:qaqc") &&
			localStorage.getItem("isActivePouredUser") === "true" &&
			getItem("QA/QC", "qc/menu", <DatabaseOutlined />),

		hasPermission("menu:57logistics") &&
			getItem("Logistics", "logistics", <DatabaseOutlined />, [
				getItem("Logistics Dashboard", "57logistics/dasboard"),
			]),
		hasPermission("menu:plant-operations") &&
			getItem("Plant Operations", "plantoperations", <DatabaseOutlined />, [
				getItem("Eticket Consolidated Report", "reports/eticket/job/zip"),
				getItem("Sales by Plant Report", "report/sales/byplant"),
				getItem("Order Relocation Report", "report/order/relocation"),
			]),
		hasPermission("menu:logistics-operations") &&
			getItem(
				"Logistics Operations",
				"logisticsoperations",
				<DatabaseOutlined />,
				[
					getItem("Truck Yards", "reports/operations/truckyards"),
					getItem("E-Ticket Trips Report", "reports/operations/trips"),
					getItem("Total trips per truck", "reports/operations/tripspertruck"),
					getItem(
						"Total trips per driver",
						"reports/operations/tripsperdriver",
					),
					getItem("Miles per truck", "reports/operations/milespertruck"),
					getItem("Miles per driver", "reports/operations/milesperdriver"),
					getItem("Diesel Loading Report", "reports/operations/dieselloading"),
					getItem("Lineup Range", "reports/operations/lineuprange"),
					getItem("Rounds per Truck", "reports/operations/roundspertruck"),
				],
			),

		// (localStorage.getItem("role") === "Admin" ||
		// 	localStorage.getItem("role") === "Finance" ||
		// 	localStorage.getItem("email") === "dm@57concrete.com") &&
		// 	localStorage.getItem("email") !== "pc@57concrete.com" &&
		// 	localStorage.getItem("email") !== "gg@57xgroup.com" &&
		// 	localStorage.getItem("email") !== "jc@57concrete.com" &&
		// 	localStorage.getItem("email") !== "scale@filegonia.com" &&
		// 	localStorage.getItem("email") !== "pc@57concrete.com" &&
		// 	localStorage.getItem("email") !== "reyesss22@icloud.com" &&
		// 	localStorage.getItem("email") !== "office@57logistics.com" &&
		// 	localStorage.getItem("email") !== "jip@57concrete.com" &&
		// 	localStorage.getItem("email") !== "office@castlereadymix.com" &&
		// 	getItem("Trucks Map", "trucksmap", <TruckOutlined />),

		hasPermission("menu:lineup") &&
			getItem("Lineup", "lineup", <FileOutlined />),

		hasPermission("menu:finance") &&
			getItem("Finance", "finance", <PieChartOutlined />, [
				getItem("Referrals", "referrallist"),
				getItem("Daily Sales", "dailysales"),
				getItem("Period Sales", "periodsales"),
				// getItem("Customer with invoices", "clientwithinvoice"),
				getItem("Payment Report", "paymentreport"),
				getItem("Mix Design Invoices", "mixdesignreport"),
				hasPermission("finance:loan-dashboard") &&
					getItem("Loan Dashboard", "loan/dashboard"),
				hasPermission("finance:office-vehicles") &&
					getItem("Office Vehicles", "office/vehicle/list"),
				hasPermission("finance:office-trucks") &&
					getItem("Office Trucks", "office/truck/list"),
				hasPermission("finance:lien-dashboard") &&
					getItem("Lien Dashboard", "lien/dashboard"),
				hasPermission("finance:mixdesign-calculator") &&
					getItem("Mix Design Cost Calculator", "mixdesign/cost/list"),
				getItem("Loads Time Surge", "report/load/timesurge"),
				// getItem("Sales by Seller Report", "report/sales/byseller"),
				// getItem("Seller Report", "report/sales/seller"),
				// getItem("Sales by Plant Report", "report/sales/byplant"),
				// (localStorage.getItem("email") === "gg@57xgroup.com" ||
				// 	localStorage.getItem("email") === "jc@57concrete.com" ||
				// 	localStorage.getItem("email") === "pc@57concrete.com" ||
				// 	localStorage.getItem("email") === "ec@57concrete.com" ||
				// 	localStorage.getItem("email") === "eliud@gmail.com") &&
				// 	getItem("Jobs Psi Innactive Report", "report/jobpsi/innactive"),
			]),

		// localStorage.getItem("email") !== "office@castlereadymix.com" &&
		// 	getItem("Containers", "container/dashboard", <AreaChartOutlined />),
		hasPermission("menu:franchises") &&
			getItem("Franchises", "franchises", <BuildOutlined />, [
				getItem("Franchises Yards", "franchises/dashboard"),
				getItem("Franchises Directions", "franchises/directions"),
			]),
		hasPermission("menu:claims") &&
			getItem("Claims", "claim/dashboard", <WarningOutlined />),
		hasPermission("menu:uploads") &&
			getItem("Uploads", "uploadlist", <UploadOutlined />),
		hasPermission("menu:prejob") &&
			getItem("Pre Jobs", "prejob/dashboard", <DatabaseOutlined />),
		hasPermission("menu:tasks") &&
			getItem("Tasks", "task/dashboard", <DatabaseOutlined />),
		hasPermission("menu:transactions") &&
			getItem("Transaction", "transaction/dashboard", <UploadOutlined />),
		hasPermission("menu:directors-management") &&
			getItem(
				"Directors Management",
				"directorsmanagement",
				<SlidersFilled />,
				// [
				// 	// getItem(
				// 	// 	"Diesel Loading Report",
				// 	// 	"reports/operations/director/dieselloading"
				// 	// ),
				// ]
			),

		hasPermission("menu:operations") &&
			getItem("Operations", "operations", <SlidersFilled />, [
				hasPermission("reports:operations:etickets") &&
					getItem("E-Tickets Report", "reports/operations/etickets"),
				hasPermission("reports:operations:etickets-modified") &&
					getItem("Etickets Modified", "reports/operations/modified"),
				hasPermission("reports:operations:etickets-average-time") &&
					getItem(
						"E-Ticket Average Time Report",
						"reports/operations/averagetime",
					),
				// getItem("Production CheckIn Report", "reports/operations/production"),
				hasPermission("reports:operations:production-efficiency") &&
					getItem("Production Efficiency", "reports/operations/efficiency"),
				getItem(
					"Production Daily Report",
					"reports/operations/production/daily",
				),
				getItem(
					"Production Weekly Report",
					"reports/operations/production/weekly",
				),
				getItem(
					"Production Monthly Report",
					"reports/operations/production/monthly",
				),
			]),

		hasPermission("menu:reports") &&
			getItem("Reports", "reports", <ProfileOutlined />, [
				getItem("Default Job Report", "reportjob"),
				getItem("Scheduled Sales Report", "report/sales/scheduled"),
				getItem("Waste Report", "report/job/waste"),
				getItem("Default Franchise Job Report", "reportjobfranchise"),
				getItem("Default Load Report", "reportload"),
				getItem("Custom Job Report", "newreport"),
				getItem("Report Catalog", "reportlist"),
				getItem("Capacity Report", "capacity"),
				getItem("Availability Report", "availability"),
				getItem("Truck Efficiency", "truckefficiency"),
				getItem("Clock Report", "clockreport"),
				getItem("Driver Trips", "report/driver/trips"),
				getItem("Driver Payments", "reportpaymentdriver"),
				getItem("Truck Trips", "reporttrucktrips"),
				getItem("Inspections", "inspections", <ProfileOutlined />, [
					hasPermission("reports:inspections:main") &&
						getItem("Inspections Report", "reports/inspections/allinspections"),
					hasPermission("reports:inspections:driver") &&
						getItem("Inspections Driver Report", "reports/inspections/driver"),
					hasPermission("reports:inspections:defects") &&
						getItem("Inspections Defects", "reports/inspections/defects"),
					hasPermission("reports:inspections:failures") &&
						getItem("Failures Report", "reports/inspections/failures"),
				]),

				getItem("Quality Control Jobs", "reportqualitycontrol"),
				hasPermission("reports:history") &&
					getItem("History of Loads and Jobs", "historyreport"),
				getItem("Job Yards By Week", "reports/job/yardsbyweek"),
				getItem("Job Check In Report", "reports/job/checkin"),
				hasPermission("reports:job:psi") &&
					getItem("Job Per Psi Report", "reports/job/psi"),
				hasPermission("reports:customer:type") &&
					getItem("Customer Type List Report", "reports/customer/type"),
				getItem("Weekly Schedule Report", "reports/job/weeklyschedule"),
				getItem(
					"Job Download Tax Type",
					"job/download/taxtype",
					<DatabaseOutlined />,
				),
			]),

		(hasPermission("menu:work-orders") ||
			localStorage.getItem("manager") === true ||
			localStorage.getItem("director") === true) &&
			getItem("WO", "wo", <ProfileOutlined />, [
				hasPermission("work-orders:main") &&
					getItem("Work Orders", "workorders"),
				hasPermission("work-orders:mechanic") &&
					getItem(
						"My Work Orders",
						`workorders/${localStorage.getItem("userId")}`,
					),
			]),

		hasPermission("menu:inventory") &&
			getItem("Inventory", "inventory", <ProductOutlined />, [
				hasPermission("inventory:dashboard") &&
					getItem("Inventory Dashboard", "inventory/dashboard"),
				getItem("Inventory Reception", "reception/list", <DatabaseOutlined />),
			]),
		// (localStorage.getItem("email") === "eliud@gmail.com" ||
		// 	localStorage.getItem("email") === "ec@57concrete.com" ||
		// 	localStorage.getItem("email") === "bp@57concrete.com" ||
		// 	localStorage.getItem("email") === "bpa@57concrete.com" ||
		// 	localStorage.getItem("email") === "jp@57concrete.com" ||
		// 	localStorage.getItem("email") === "fc@57concrete.com" ||
		// 	localStorage.getItem("email") === "ji@57concrete.com" ||
		// 	localStorage.getItem("email") === "mgr@57concrete.com" ||
		// 	localStorage.getItem("role") === "AP" ||
		// 	localStorage.getItem("manager") === true ||
		// 	localStorage.getItem("director") === true) &&
		// 	localStorage.getItem("email") !== "office@castlereadymix.com" &&
		// 	getItem("Inventory", "inventory", <ProductOutlined />, [
		// 		getItem("Inventory", "inventorylist"),
		// 		getItem("Provider", "providerlist"),
		// 		getItem("Request Inventory", "inventoryrequestedlist"),
		// 	]),

		hasPermission("menu:rh") &&
			getItem("RH", "rh", <TeamOutlined />, [
				getItem("Employees", "employees"),
				getItem("Departments", "departments"),
				getItem("Positions", "positions"),
				hasPermission("rh:email-validation") &&
					getItem("Email Validation", "emailsvalidation"),
			]),
		hasPermission("menu:web-logistics") &&
			getItem("Web Logistics", "weblogisitcs", <TeamOutlined />, [
				getItem("Material Schedule", "logistics/material/schedule"),
				getItem("Material Delivered", "logistics/material/delivered"),
				// getItem("Logistics Dashboard", "logistics/dashboard"),
				// getItem("Logistics Drivers", "logisticsdriverlist"),
				// getItem("Logistics Trucks", "logisticstrucklist"),
				// getItem("Logistics Materials", "logistics/material/list"),
				// getItem("Logistics Origins", "logistics/origin/list"),
				// getItem("Logistics Destinations", "logistics/destination/list"),
				// getItem("Logistics Routes", "logistics/route/list"),
				// getItem("Logistics Reports", "logisticsreports", <ProfileOutlined />, [
				// 	getItem("Inspections", "reports/logistics/inspections"),
				// 	getItem("Inspections Driver", "reports/logistics/inspectionsdriver"),
				// 	getItem("Total general trips", "reports/logistics/generaltrips"),
				// 	getItem("Total trips per truck", "reports/logistics/tripspertruck"),
				// 	getItem("Total trips per driver", "reports/logistics/tripsperdriver"),
				// 	getItem(
				// 		"Tons per material per client",
				// 		"reports/logistics/materialperplant",
				// 	),
				// 	getItem("Miles per truck", "reports/logistics/milespertruck"),
				// 	getItem("Miles per driver", "reports/logistics/milesperdriver"),
				// 	getItem("Rate Per Loads", "reports/logistics/rateperload"),
				// ]),
			]),

		hasPermission("menu:settings") &&
			getItem("Settings", "settings", <SettingOutlined />),
		hasPermission("menu:ai-assistant") &&
			getItem("AI Assistant", "ai-assistant", <SettingOutlined />),

		hasPermission("menu:forecast") &&
			getItem(
				"Forecast",
				`forecastbyseller/${localStorage.getItem("userId")}`,
				<UnorderedListOutlined />,
			),

		getItem("Logout", "", <LogoutOutlined />),
	];

	let location = useLocation();
	const [itemList, setItemList] = useState([]);
	const [current, setCurrent] = useState(
		location.pathname === "/" || location.pathname === ""
			? ""
			: location.pathname.replace("/", ""),
	);
	useEffect(() => {
		if (location) {
			setItemList(items);
			if (current !== location.pathname) {
				setCurrent(location.pathname);
			}
		}
	}, [location, current]);

	function handleClick(e) {
		setCurrent(e.key);
		if (e.key === "") {
			logout();
			history.push("/");
		} else {
			history.push(`/${e.key}`);
		}
	}

	return (
		<>
			{localStorage.getItem("role") !== null && (
				<Menu
					theme="dark"
					mode="horizontal"
					defaultSelectedKeys={[current]}
					items={itemList}
					style={{
						flex: 1,
						minWidth: 0,
					}}
					onClick={handleClick}
				/>
			)}

			{localStorage.getItem("role") !== null && <NotificationManager />}
		</>
	);
};

Menu.propTypes = {
	logout: PropTypes.func.isRequired,
	auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
	auth: state.auth,
});

export default connect(mapStateToProps, { logout })(withRouter(CustomMenu));
